import { GA4EventName, GA4FeatureCategory, trackAnalyticsEvent } from '@jsmdg/tracking';

async function startVideo(duration: string): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.StartVideo,
            feature_category: GA4FeatureCategory.ProductdetailGallery,
            duration,
        },
    });
}

export { startVideo };
